import { ImpactCo2Answer } from '@/domain/impact-co2/entities/question.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  projectId: number;
};

export const getImpactCo2Answers = createAppAsyncThunk(
  'impactCo2/getImpactCo2Answers',
  async (
    params: Params,
    { extra: { impactCo2Gateway, snackbarGateway } },
  ): Promise<ImpactCo2Answer[]> => {
    try {
      const answers = await impactCo2Gateway.getImpactAnswers(params.projectId);
      return answers;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCo2Answers.Message.error'));
}
